import React from 'react';
import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Home from './pages/Home'
import AuthSilentSignIn from './components/AuthSilentSignIn';
import AuthPreLogin from './components/AuthPreLogin';
import Circuito from './pages/unAuth/Circuito';
import CallBack from './components/CallBack';
import Mercato from './pages/unAuth/Mercato';
import HomeAuth from './pages/auth/HomeAuth';
import AssociationsList from './pages/AssociationsList';
import RegisterCompany from './components/RegisterCompany';
import RegisterCallBack from './components/RegisterCallBack';
// import MarketsList from './pages/MarketsList';
import NotFound from './components/NotFound';
import MarketsGeo from './components/Network/MarketsGeo';
import TransactionsAuth from './pages/auth/TransactionsAuth';
import BuyTokens from './pages/auth/BuyTokens';
import WithdrawTokens from './pages/auth/WithdrawTokens';
import AcceptRejectWithdraw from './components/Withdraw/AcceptRejectWithdraw';
import DefaultCompanyAndAssociationPage from './pages/auth/DefaultCompanyAndAssociationPage';
import MarketForm from './components/Markets/MarketForm';
import Deposit from './components/Deposit';
import Redeem from './components/Redeem';
import DefaultAdminOrAssociationPage from './pages/auth/DefaultAdminOrAssociationPage';
import Asso from './pages/unAuth/Asso';
import Platform from './pages/unAuth/Platform';
import RegisterPrivate from './pages/unAuth/RegisterPrivate';
import RegisterEconomicsCompany from './pages/unAuth/RegisterEconomicsCompany';
import RegisterAssociation from './pages/unAuth/RegisterAssociation';
import DefaultFidelityPage from './pages/auth/DefaultFidelityPage';
import { FidelityPoints } from './components/FidelityPoints';
import { PresentCircuit } from './components/PresentCircuit';
import CreditsTable from './components/CreditsList';
import UserInfos from './components/UserInfo/UserInfos';
import ChangePassword from './components/ChangePassword/ChangePassword';
import DefaultCompanyPage from './pages/auth/DefaultCompanyPage';
import MarketList from './components/Markets/MarketList';
import { SellInNetwork } from './components/SellInNetwork';
import { MarketInfo } from './components/MarketInfo';
import Network from './components/Network';
import HomeRegister from './pages/HomeRegister';
import { CloseAccount } from './components/ChiudiAccount';
import ConfirmaRecjectCloseUserAccount from './components/ChiudiAccount/ConfirmaRecjectCloseUserAccount';
import NationalEntityRoute from './components/NationalEntityRoute';

function App() {
  return (
    <>
      <AuthPreLogin />
      <AuthSilentSignIn />
      <Routes>
        <Route path="/" element={<Layout children={<HomeRegister />} />} /> 
        <Route path='/private/register' element={<Layout children={<RegisterPrivate />} />} />
        <Route path='/economics-activities/register' element={<Layout children={<RegisterEconomicsCompany />} />} />
        <Route path='/associations/register' element={<Layout children={<RegisterAssociation />} />} />
        <Route path="/asso" element={<Layout children={<Asso />} />} /> 
        <Route path="/platform" element={<Layout children={<Platform />} />} /> 
        <Route path="/network" element={<Layout children ={<Circuito />}/>} />
        <Route path="/associations" element={<Layout children ={<AssociationsList />}/>} />
        {/* <Route path="/markets" element={<Layout children ={<MarketsList />}/>} /> */}
        <Route path="/market" element={<Layout children ={<Mercato />}/>} />
        {/* <Route path="/contacts" element={<Layout children ={<Contacts />}/>} /> */}
        <Route path="/authorize/callback" element={<Layout children={<CallBack />} />} />
        <Route path="/company/register/:userRef" element={<Layout children={<RegisterCompany/>} />} />
        <Route path="/company/register/" element={<Layout children={<RegisterCompany/>} />} />
        <Route path="/company/register/callback" element={<Layout children={<RegisterCallBack />} />} /> 
        <Route path="/withdraw/:action" element={<Layout children={<AcceptRejectWithdraw />} />} />
        <Route path="/close-account/:action" element={<Layout children={<ConfirmaRecjectCloseUserAccount />} />} />

        {/** AUTH */}
        <Route path="/home" element={<Layout children={<HomeAuth />} />} /> 
        <Route path="/transactions" element={<Layout children={<TransactionsAuth type={0}/>} />} /> 
        <Route path="/buy" element={<Layout children={<NationalEntityRoute><BuyTokens /></NationalEntityRoute>} />} /> 
        <Route path="/market/info" element={<Layout children={<MarketInfo />} />} /> 
        <Route path="/buy/transactions" element={<Layout children={<NationalEntityRoute><TransactionsAuth type={1}/></NationalEntityRoute>} />} /> 
        <Route path="/withdraw" element={<Layout children={<WithdrawTokens />} />} />
        <Route path="/network/list" element={<Layout children ={<Network />}/>} />
        <Route path="/activity" element={<Layout children={<DefaultCompanyAndAssociationPage children={<MarketForm />} />} />} />
        <Route path="/activity/:marketId" element={ <Layout children={<DefaultCompanyAndAssociationPage children={<MarketForm />} />} />} />
        <Route path="/deposit" element={ <Layout children={<DefaultCompanyAndAssociationPage titleType={0} children={<Deposit/>} />} />} />
        <Route path="/redeem" element={ <Layout children={<NationalEntityRoute><DefaultCompanyAndAssociationPage titleType={1} children={<Redeem/>} /></NationalEntityRoute>} />} />
        <Route path="/sell-in-network" element={ <Layout children={<DefaultCompanyAndAssociationPage titleType={2} children={<SellInNetwork/>} />} /> }/>
        <Route path="/fidelity" element={<Layout children={ <DefaultFidelityPage titleType={0} children={<FidelityPoints/>} />} />} />
        <Route path="/present-circuit" element={<Layout children={ <DefaultFidelityPage titleType={1} children={<PresentCircuit/>} />} />} />
        <Route path="/credits/list" element={<Layout children={ <DefaultFidelityPage titleType={2} children={<CreditsTable/>} />} />} />
        <Route path="/user/info" element={<Layout children={<UserInfos />}/>}/>
        <Route path="/user/change-password" element={<Layout children={<ChangePassword />}/>}/>
        <Route path="/user/economics-activities" element={ <Layout children={<DefaultCompanyPage titleType={0} children={<MarketList/>} />} />} />
        <Route path="/close-account" element={<Layout children={<CloseAccount />}/>}/>

        {/** AUTH SUPERADMIN, DEVSUPERADMIN, OR ASSOCIATION */}
        <Route path="/admin" element={ <Layout children={<DefaultAdminOrAssociationPage/>} />} />

        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/404" element={<Layout children={<NotFound/>} />} /> 
      </Routes>
    </>
  );
}

export default App;